import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';

import {labels} from '../../../../../../util/utils';

import {clearErrors} from '../../../../../../actions/erroractions';
import {setIsModalOpen} from '../../../../../../actions/AccessGroups/SetIsModalOpen';

import normalizeContactList from '../../GenerateMessage/GMForm/utils/normalizeContactList';
import getAvailableEntityList from '../../GenerateMessage/GMForm/utils/getAvailableEntityList';
import {
	FROM_ENGAGEMENT,
	FROM_ENTITY,
	FROM_ENTITY_NOTIFICATION,
	LINK,
	LINK_LABEL,
	NOTIFICATION_MESSAGE,
	RECIPIENTS_SELECTED_LIST,
	SUBJECT,
	TYPE,
	getTypeEmail,
	getTypeNotification
} from '../../GenerateMessage/GMForm/utils/constants';

import GMForm from '../../GenerateMessage/GMForm';
import getSelectedContacts from './getSelectedContacts';

const DuplicateMessage = ({
	showModal,
	setShowModal,
	hideMessageLog,
	contactsList,
	isEmail,
	subject,
	from,
	fromEngagement,
	message,
	link,
	filters
}) => {
	const storeContactList = useSelector(({contacts}) =>
		contacts?.entities?.length > 0 ? normalizeContactList(getAvailableEntityList(contacts.entities, false)) : []
	);

	const selectedContacts = getSelectedContacts(contactsList, storeContactList);

	const dispatch = useDispatch();

	const setModalErrors = (val) => dispatch(clearErrors()).then(() => dispatch(setIsModalOpen(val)));

	const hideModal = () => {
		setShowModal(false);
	};

	const typeEmail = getTypeEmail(labels.email);
	const typeNotification = getTypeNotification(labels.notification);

	const props = {
		showModal,
		hideModal,
		duplicateMessage: {
			hideMessageLog,
			filters,
			values: {
				[RECIPIENTS_SELECTED_LIST]: [...selectedContacts],
				[TYPE]: isEmail ? typeEmail : typeNotification,
				[SUBJECT]: subject
			}
		}
	};

	if (isEmail) {
		props.duplicateMessage.values[FROM_ENTITY] = {
			label: from.entityName,
			value: from.entityId,
			id: from.entityId
		};
		props.duplicateMessage.values[FROM_ENTITY_NOTIFICATION] = null;
	} else {
		props.duplicateMessage.values[FROM_ENTITY_NOTIFICATION] = {
			label: from.entityName,
			value: from.entityId,
			id: from.entityId
		};
		props.duplicateMessage.values[FROM_ENTITY] = null;
		props.duplicateMessage.values[FROM_ENGAGEMENT] = {
			label: fromEngagement.name,
			value: fromEngagement.id,
			id: fromEngagement.id
		};
		props.duplicateMessage.values[NOTIFICATION_MESSAGE] = message;
		if (link !== undefined) {
			props.duplicateMessage.values[LINK_LABEL] = link.label;
			props.duplicateMessage.values[LINK] = link.link;
		} else {
			props.duplicateMessage.values[LINK_LABEL] = '';
			props.duplicateMessage.values[LINK] = '';
		}
	}

	return <GMForm {...props} />;
};

DuplicateMessage.propTypes = {};

DuplicateMessage.defaultProps = {};

export default DuplicateMessage;
